var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"app-alert",attrs:{"type":_vm.type,"dismissible":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},_vm._l((_vm.messages),function(message,index){return _c('p',{key:index,staticClass:"mb-0"},[_vm._v("\n    "+_vm._s(message)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }